import React from "react";
import PropTypes from "prop-types";

import TakeoverPanel from "components/library/TakeoverPanel";
import TakeoverHeader from "components/library/TakeoverHeader";
import Button from "components/library/Button";

import styles from "./Confirmation.css";

export default function Confirmation({
  children,
  header,
  clickText,
  onClick,
  wasClicked,
  cancelText,
  onCancel,
}) {
  return (
    <TakeoverPanel containerStyle={styles.takeover}>
      <TakeoverHeader className={styles.header}>{header}</TakeoverHeader>

      <div className={styles.wrapper}>{children}</div>

      <Button type="submit" onClick={onClick} isDisabled={wasClicked}>
        {clickText}
      </Button>
      <Button type="cancel" onClick={onCancel}>
        {cancelText}
      </Button>
    </TakeoverPanel>
  );
}

Confirmation.defaultProps = {
  clickText: "Yes, update",
  cancelText: "No, cancel",
};

Confirmation.propTypes = {
  children: PropTypes.node,
  header: PropTypes.string,
  clickText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  cancelText: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  wasClicked: PropTypes.bool.isRequired,
};
